module.exports = __webpack_public_path__ + "img/modern-floral.33d51065.jpg";